import { render, staticRenderFns } from "./TarifariosForm.vue?vue&type=template&id=29b69883"
import script from "./TarifariosForm.vue?vue&type=script&lang=js"
export * from "./TarifariosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports